import React from 'react';
import { processNodes } from '../processNodes.js';
import { generatePropsFromAttributes } from '../utils/generatePropsFromAttributes.js';
import { isValidTagOrAttributeName } from '../utils/isValidTagOrAttributeName.js';
import { isTag } from 'domhandler';
import { VOID_ELEMENTS } from '../dom/elements/VoidElements.js';
export function processTagNode(node, index, transform) {
    if (!isTag(node)) {
        return null;
    }
    const tagName = node.tagName;
    if (!isValidTagOrAttributeName(tagName)) {
        return null;
    }
    const props = generatePropsFromAttributes(node.attribs, index);
    let children = null;
    if (VOID_ELEMENTS.indexOf(tagName) === -1) {
        children = processNodes(node.children, transform);
    }
    return React.createElement(tagName, props, children);
}
//# sourceMappingURL=ProcessTagNode.js.map